import React from "react";
import { Box, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import SwitchAccordion from "./SwitchAccordion";

const BasicAccordionWithSwitch = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Accordion with switch
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              '             <SwitchAccordion title={"Accordion 1"} checked={true}>\n' +
              "                <Typography>\n" +
              "                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
              "                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis\n" +
              "                  eget.\n" +
              "                </Typography>\n" +
              "              </SwitchAccordion>\n\n\n" +
              '              <SwitchAccordion title={"Accordion 2"}  checked={true}>\n' +
              "                <Typography>\n" +
              "                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
              "                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis\n" +
              "                  eget.\n" +
              "                </Typography>\n" +
              "              </SwitchAccordion>\n\n\n" +
              '              <SwitchAccordion title={"Accordion 3"}  checked={true}>\n' +
              "                <Typography>\n" +
              "                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n" +
              "                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis\n" +
              "                  eget.\n" +
              "                </Typography>\n" +
              "              </SwitchAccordion>"
            }
          >
            <div>
              <SwitchAccordion title={"Accordion 1"}>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </SwitchAccordion>
              <SwitchAccordion title={"Accordion 2"}>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </SwitchAccordion>
              <SwitchAccordion title={"Accordion 3"}>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </SwitchAccordion>
            </div>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicAccordionWithSwitch;
